import { CSSProperties } from 'react';
import styled from 'styled-components';
import { Button } from '@mui/material';

export const Container = styled.div`
	padding: 0 6%;
	.verify {
		background: var(--action-accent-surface);
		width: 15em;
		height: 4em;
		border: none;
		margin-left: auto;
	}

	.hide {
		display: none;
	}
`;

export const Content = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	.buttonPesquisa {
		background: var(--action-accent-surface);
		width: 15em;
		height: 4em;
	}
`;

export const Title = styled.h4`
	font-weight: 500;
	font-size: 31px;
	line-height: 36px;
	color: var(--text-primary);
	margin: 40px 10px;
`;

export const SubTitle = styled.span`
	font-weight: 700;
	font-size: 24px;
	line-height: 24px;
	letter-spacing: 0.18px;
	color: var(--text-primary);
	display: inline-block;
	margin-bottom: 30px;
`;

export const Form = styled.div`
	display: inline-flex;
	flex-direction: column;
	align-items: flex-end;
	width: 100%;
`;

export const FormField = styled.div`
	width: 100%;
	display: flex;
	margin: 10px;
`;

export const Text = styled.span`
	max-width: 140px;
	min-width: 140px;
	font-size: 16px;
	line-height: 24px;
	text-align: right;
`;

export const Input = styled.input`
	display: none;
`;

export const InputStyled: CSSProperties = {
	maxWidth: '360px',
	minWidth: '140px',
	marginRight: '30px',
};

export const InputFormStyled: CSSProperties = {
	maxWidth: '360px',
	minWidth: '140px',
};

export const StyledTh = styled.th`
	padding: 10px;
	border-width: 2px;
	border-radius: 10px;
`;

export const StyledTr = styled.tr`
	transition: background-color 0.2s ease;
	
	&:hover {
		background-color: var(--surface-sunken);
	}
`;

export const StyledTd = styled.td`
	text-align: center;
	vertical-align: middle;
	padding: 12px 8px;
	border-bottom: 1px solid var(--border-default);
`;

export const StyledTdActions = styled.td`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 12px 8px;
	border-bottom: 1px solid var(--border-default);
`;

export const StyledDate = styled.span`
	font-size: 14px;
	color: var(--text-secondary);
	white-space: nowrap;
`;

export const StyledButtonEdit = styled(Button)`
	&& {
		width: 5.4em;
	}
`;

export const StyledButtonDelete = styled(Button)`
	&& {
		width: 5.7em;
		margin-left: 5px;
	}
`;

export const StyledDividerRow = styled.tr`
	background: transparent;
`;

export const StyledDividerTd = styled.td`
	padding: 0;
	border: none;
`;

export const TableHeader = styled.thead`
	background: var(--action-accent-surface);
`;

export const Load = styled.div`
	background: var(--border-accent);
	border-radius: 5px;
	max-width: 20%;
	margin-top: 15px;
	margin-bottom: 15px;
	padding-top: 10px;
	padding-bottom: 10px;
	display: flex;
	div {
		margin-left: 15px;
		img{
			width: 30px;
			height: 30px;
		}
	}
	span {
		font-family: var(--font-body);
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 16px;
		display: flex;
		align-items: center;
		text-align: center;
		letter-spacing: 1.25px;
		text-transform: capitalize;
		color: var(--text-primary);
	}
`;

export const LoadFile = styled.span`
	display: flex;
`;

export const AddNewFile = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 33px;
	margin-left: 15%;
	cursor: pointer;
`;

export const ContainerForm = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 33px;
`;

export const ContainerTextArea = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-bottom: 33px;
`;

export const StyledSendButton = styled(Button)`
  && {
    background-color: var(--action-accent-surface);
    color: var(--text-primary);

    &:hover {
      background-color: var(--action-accent-surface);
    }

    &.Mui-disabled {
      background-color: var(--action-disabled-surface);
      color:var(--text-primary);
    }
  }
`;

export const IconWrapper = styled.span`
  margin-right: 4px;
`;